<template>
  <modal transition="pop-out" name="update-micro-category" :height="600">
    <div class="h-10 w-full border-b border-gray-200">
      <p class="px-8 py-2 text-gray-700 font-bold">Edit MicroCategory</p>
    </div>
    <div class="w-full">
      <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
        <div class="mb-4 mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Name
          </label>
          <input v-model="form.name" class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Category Name">
          <p v-if="errors.includes('name')" class="text-red-500 text-xs italic">Please provide a name.</p>
        </div>
        <div class="mb-4 mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Category
          </label>
          <el-select :disabled="disabled" v-model="form.category_id" @change="setSubCategories()" placeholder="Select">
            <el-option
              v-for="item in categories"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <p v-if="errors.includes('category_id')" class="text-red-500 text-xs italic">Please provide a category.</p>
        </div>
        <div class="mb-4 mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Sub Category
          </label>
          <el-select :disabled="disabled" :no-data-text="'No Subcategory'" v-model="form.sub_category_id" placeholder="Select">
            <el-option
              v-for="item in subCategories"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <p v-if="errors.includes('category_id')" class="text-red-500 text-xs italic">Please provide a sub category.</p>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Description
          </label>
          <textarea v-model="form.description" class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Description...."></textarea>
          <p v-if="errors.includes('description')" class="text-red-500 text-xs italic">Please provide some description.</p>
        </div>
        <div class="mb-6">
          <el-upload
            :action="upload_url"
            accept="image/jpeg, image.png">
            <el-button size="small">Choose micro-category image</el-button>
          </el-upload>
        </div>
        <div class="flex items-center justify-between">
          <el-button @click="submit" type="primary" :loading="updating">Create</el-button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'UpdateForm',
  props: {
    upload_url: {
      type: String,
    },
  },
  data() {
    return {
      updating: false,
      update_image: false,
      subCategories: [],
      errors: [],
      disabled: true,
    };
  },
  computed: {
    form() {
      const data = cloneDeep(this.$store.state.InventoryModule.Catalog.currentSelected.microCategory) || {};
      if (Object.keys(data).length > 0) {
        if (this.$route.name === 'micro-category') {
          data.category_id = parseInt(this.$route.params.category_id, 10);
          data.sub_category_id = parseInt(this.$route.params.subCategory_id, 10);
        }
      }

      return data;
    },
    categories() {
      return this.$store.getters['InventoryModule/Catalog/getCategoryForSelect'];
    },
  },
  methods: {
    async submit() {
      this.errors = [];
      // formValidation is a mixin in
      // src/Common/mixins/index.js
      this.errors = this.formValidation(this.form);

      // check for error length
      if (this.errors.length === 0) {
        try {
          this.updating = true;

          const formData = {
            name: this.form.name,
            description: this.form.description,
            category_id: this.form.category_id,
            sub_category_id: this.form.sub_category_id,
          };
          await this.$store.dispatch('InventoryModule/Catalog/updateMicroCategory', {
            data: formData,
            microCategoryId: this.form.id,
            category: this.getSelectedCategory(),
            subCategory: this.getSelectedSubCategory(),
          });

          this.$modal.hide('update-micro-category');
          this.$notify.success({
            title: 'Success',
            message: 'SubCategory successfully updated',
          });
        } catch (e) {
          this.updating = false;
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong',
          });
        }

        this.updating = false;
      }
    },

    getSelectedCategory() {
      return this.categories.filter(item => item.value === this.form.category_id);
    },

    getSelectedSubCategory() {
      return this.subCategories.filter(item => item.value === this.form.sub_category_id);
    },

    setSubCategories() {
      this.subCategories = this.$store.getters['InventoryModule/Catalog/getSubCategoryForSelect'](this.form.category_id);
    },
  },

  mounted() {
    this.setSubCategories();
    if (this.$route.name !== 'micro-category') {
      this.disabled = false;
    }
  },
};
</script>

<style scoped>

</style>
